import Api from "./Api";

const CALENDAR_ID = 'Calendar_id'

export default class CalendarSync {

  static myInstance: CalendarSync
  private api = Api.getInstance();
  public calendarSet: boolean
  public calendarId: number

  constructor() {
    this.calendarSet = true
    this.calendarId = 0
  }

  setCalendar = (calendarId: number) => {
    window.localStorage[CALENDAR_ID] = calendarId
    this.calendarId = calendarId
  }

  storeLocally = () => {
    if (this.calendarSet) {
      window.localStorage[CALENDAR_ID] = this.calendarId
    }
  }

  fetchLocally = () => {
    const data = window.localStorage[CALENDAR_ID]
    if (data !== 'undefined') {
      this.calendarId = data
    } else {
      this.calendarId = 0
    }
  }

  removeLocally = () => {
    delete window.localStorage[CALENDAR_ID]
  }

  static getInstance(): CalendarSync {
    if (CalendarSync.myInstance == null) {
      CalendarSync.myInstance = new CalendarSync();
    }
    return this.myInstance;
  }
}
